import { render, staticRenderFns } from "./TagsIcon.vue?vue&type=template&id=d460ca08&scoped=true"
import script from "./TagsIcon.vue?vue&type=script&lang=js"
export * from "./TagsIcon.vue?vue&type=script&lang=js"
import style0 from "./TagsIcon.vue?vue&type=style&index=0&id=d460ca08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d460ca08",
  null
  
)

export default component.exports